import axios from 'axios';
import React from 'react';
import { components } from "react-select";
import * as Common from '../mc/Common';

export const handleInputChange = (value) => {
    // setInputValue(value);
}

export const fetchLocationAllowedPicklist = (searchString) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'locationallowed',
        srch: searchString
    };
    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });
    return result;
}

export const fetchLedgerAllowedPicklist = (searchString, location) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'ledgerallowed',
        srch: searchString,
        location: location
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}

export const expensePicklist = (searchString) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'expensePicklist',
        srch: searchString
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}

export const fetchLedgerAllowedWithGroupPicklist = (searchString, location) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'ledgerallowedwithgroup',
        srch: searchString,
        location: location
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}

//picklist for  additional credit limit component 
export const fetchLedgerAdditionalCreditAllowedPicklist = (searchString, location) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'additionalCreditledgerallowed',
        srch: searchString,
        location: location
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}

export const fetchIndividualPicklist = (searchString, trantype = "PURCHASE") => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'individual',
        srch: searchString,
        trantype: trantype,
        a: "b"
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        //console.log(JSON.parse(result.data.replace(/\\/g, '')))
        return JSON.parse(result.data.replace(/\\/g, ''));
    });

    return result;
}
export const fetchPurposeAdi = (searchString) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'purposeADI',
        srch: searchString,
    };
    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data.replace(/\\/g, ''));
    });
    return result;
}

export const fetchLedgerPicklistByType = (searchString, grouptype, location) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'ledgerfromtype',
        srch: searchString,
        grouptype: grouptype,
        location: location
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}

export const fetchLedgerPicklistByTypeNoValidityCheck = (searchString, grouptype, location) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'ledgerfromtype',
        srch: searchString,
        grouptype: grouptype,
        location: location,
        validitycheck: false
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}

export const fetchCurrencyAllowedPicklist = (searchString, product) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'currencyallowed',
        srch: searchString,
        product: product
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}

export const fetchVtmEncashmentPicklist = (searchString, status, location, individualSrno, hdrDateYMD) => {
    if (individualSrno == "") return null;

    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'vtmencashment',
        srch: searchString,
        status: status,
        location: location,
        individualSrno: individualSrno,
        hdrDateYMD: hdrDateYMD
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}

export const fetchExecutivePicklist = (searchString) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'executive',
        srch: searchString
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}
export const fetchSubExecutivePicklist = (searchString) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'sub_executive',
        srch: searchString
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}
export const fetchAirlinesPicklist = (searchString) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'airlines',
        srch: searchString
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}
export const fetchAllBankPicklist = (searchString) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'allbank',
        srch: searchString
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}
export const fetchAllIds = (searchString, type) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: "allids",
        trantype: type,
        srch: searchString
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}

export const fetchPurposePicklist = (searchString) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'purpose',
        srch: searchString
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}
export const fetchPurchasePurposePicklist = (searchString) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'purchasepurpose',
        srch: searchString
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}
export const fetchSourceOfFundPicklist = (searchString) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'sourceoffund',
        srch: searchString
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}
export const fetchVisaTypePicklist = (searchString) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'visatype',
        srch: searchString
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}

export const fetchCountryPicklist = (searchString) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'country',
        srch: searchString,
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}
export const fetchCountryPicklistBy3DigitISOCode = (searchString) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'country3ISO',
        srch: searchString,
        limit: 8,
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}

export const fetchIndividualMainPicklist = (searchString) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'individualList',
        srch: searchString
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}

export const fetchStatePicklist = (searchString, country) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'state',
        srch: searchString,
        country: country,
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}

export const fetchDistrictPicklist = (searchString, state) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'district',
        srch: searchString,
        state: state,
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}

export const fetchCityPicklist = (searchString, district) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'city',
        srch: searchString,
        district: district,
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}

export const fetchGroupPicklist = (searchString, grouptype) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'groupfromtype',
        srch: searchString,
        grouptype: grouptype,
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;

}

export const fetchBankPicklist = (searchString, location) => {

    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'bank',
        srch: searchString,
        location: location
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;

}
export const fetchAllBankWithOutLocationPicklist = (searchString) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'allbankwithoutlocation',
        srch: searchString
    };
    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });
    return result;
}

export const fetchLocalBankPicklist = (searchString, location) => {

    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'banklocal',
        srch: searchString,
        location: location
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;

}

export const fetchGlobalBankPicklist = (searchString, location) => {

    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'bankglobal',
        srch: searchString,
        location: location
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;

}

export const fetchChequePicklist = (searchString, location, randomString, filterDate) => {
    //console.log(randomString);
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'cheque',
        srch: searchString,
        location: location,
        randomString: randomString,
        date: filterDate
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;

}

export const fetchChequeBookBankPicklist = (searchString, groupCode, bankCode, location) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'chequebookbank',
        srch: searchString.trim(),
        groupCode: groupCode,
        bankCode: bankCode,
        location: location,
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}

export const fetchReceivedChequePicklist = (searchString, location, bankGroup, bankAccount) => {

    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'receivedcheque',
        srch: searchString,
        location: location,
        bankGroup: bankGroup,
        bankAccount: bankAccount
        // randomString: randomString
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });
    return result;
}

export const fetchIssueChequePicklist = (searchString, location, bankGroup, bankAccount) => {

    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'issuecheque',
        srch: searchString,
        location: location,
        bankGroup: bankGroup,
        bankAccount: bankAccount
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });
    return result;
}

export const fetchManualAllPicklist = (searchString, location) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'manualall',
        srch: searchString,
        location: location,
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });
    return result;
}

export const fetchManualTypePicklist = (searchString, location, trantype) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'manualtype',
        srch: searchString,
        location: location,
        trantype: trantype
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });
    return result;
}

export const fetchDealerTypePicklist = (searchString, location, dealertype, trandate) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'dealertype',
        srch: searchString,
        location: location,
        dealertype: dealertype,
        trandate: trandate,
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });
    return result;
}

export const fetchDebtorCreditorAllowedPicklist = (searchString, location, flag) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'debtorcreditorallowed',
        srch: searchString,
        location: location,
        flag: flag
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}

export const fetchProductBankPicklist = (searchString, location, groupCode, bankCode, currencyCode) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'productbank',
        srch: searchString,
        location: location,
        groupCode: groupCode,
        accountCode: bankCode,
        currencyCode: currencyCode,
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}

export const fetchKnockoffPicklist = (searchString, location, data) => {

    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'knockoff',
        srch: searchString,
        location: location,
        data: data,
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        //console.log(result.data);
        const cleaned = result.data.replace(/\n/g, '').replace(/\t/g, '');
        return JSON.parse(cleaned);
    });
    return result;
}

export const fetchVtcInlist = (searchString, reqObj) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'vtcinlist',
        srch: searchString,
        location: reqObj.location,
        group: reqObj.group,
        isd: reqObj.isd,
        account: reqObj.account,
        hdrDateYMD: reqObj.hdrDateYMD
    };
    //obj = { ...obj, ...reqObj };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });
    return result;
}

export const fetchVtcBilllist = (searchString, reqObj) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'vtcbilllist',
        srch: searchString,
        location: reqObj.location,
        group: reqObj.group,
        isd: reqObj.isd,
        account: reqObj.account,
        hdrDateYMD: reqObj.hdrDateYMD,
        individualSrno: reqObj.individual
    };
    //obj = { ...obj, ...reqObj };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });
    return result;
}

export const fetchVtSettled = (searchString, reqObj) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'vtsettled',
        srch: searchString,
        location: reqObj.location,
        group: reqObj.group,
        isd: reqObj.isd,
        account: reqObj.account,
        trtype: reqObj.type,
    };
    //obj = { ...obj, ...reqObj };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });
    return result;
}

export const fetchLocationPicklist = (searchString) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'location',
        srch: searchString
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}

export const fetchCountryofIssuePicklist = (searchString) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'countryIssue',
        srch: searchString,
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}


export const fetchBankDetailsPicklist = (searchString, location, bank) => {

    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'bankDetails',
        srch: searchString,
        location: location,
        bank: bank
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;

}

export const fetchExpenseSubPurposeDetailsPicklist = (searchString) => {

    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'expenseSubPurpose',
        srch: searchString,
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;

}


export const formatOptionLabel = ({ ID, label, desc }) => {
    const valArr = desc?.split("^");
    // const headerLength = valArr.length;
    // const id = valArr[0];
    // const name = valArr[1];
    // const panId = valArr[2];
    // const idtype = valArr[3];
    // const idNum = valArr[4];
    // const add = valArr[5];

    return (
        <div style={{ width: '100%', display: 'flex', paddingBottom: '0px' }}>
            {/* {valArr.map((data) => */}
            <>
                <div style={{ width: '28%', paddingLeft: '3%' }}>
                    {valArr[0]}
                </div>
                <div style={{ width: '22%', paddingLeft: '3%' }}>
                    {valArr[1]}
                </div>
                <div style={{ width: '30%', paddingLeft: '3%' }}>
                    {valArr[2]}
                </div>
                <div style={{ width: '20%', paddingLeft: '3%' }}>
                    {valArr[3]}
                </div>
                {/* <div style={{ width: '28%', paddingLeft: '3%', textAlign: 'left' }}>
                    {data[4]}
                </div> */}
            </>
            {/* )} */}
            {/* <div style={{ display: 'table-cell', width: '28%', padding: '5px' }}>
                <span style={{ fontWeight: 'bold', }}> <FontAwesomeIcon style={{ fontSize: '80%', color: 'red' }} icon={faUser} />{id + " " + name}</span>
            </div>
            <div style={{ display: 'table-cell', width: '22%', padding: '5px' }}>
                <span style={{ fontWeight: 'bold', }}><FontAwesomeIcon style={{ fontSize: '80%', color: 'red' }} icon={faIdCard} />{panId}</span>
            </div>
            <div style={{ display: 'table-cell', width: '35%', padding: '5px' }}>
                <span style={{ fontWeight: 'bold', }}><FontAwesomeIcon style={{ fontSize: '80%', color: 'red' }} icon={faAddressCard} />{idtype + " " + idNum} </span>
            </div>
            <div style={{ display: 'table-cell', width: '15%', padding: '5px' }}>
                <span style={{ fontWeight: 'bold', }}><FontAwesomeIcon style={{ fontSize: '80%', color: 'red' }} icon={faLocationDot} />{add}</span>
            </div> */}
        </div>
    )
}

// export const menu = (props) => (
//     <components.Menu {...props}>
//         <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//             <thead style={{ width: '100%' }}>
//                 {/* <tr style={{ width: '100%' }}> */}
//                 {/* <th >Name</th>
//                     <th >Pancard No</th>
//                     <th >Id</th>
//                     <th >Addressss</th> */}
//                 <tr style={{ width: '100%', display: 'flex', fontWeight: 'bold', backgroundColor: '#f8f9fa', }}>
//                     <div style={{ width: '28%', paddingLeft: '4%' }}>Name</div>
//                     <div style={{ width: '22%', paddingLeft: '3%' }}>Pancard no</div>
//                     <div style={{ width: '30%', paddingLeft: '3%' }}>Id</div>
//                     <div style={{ width: '20%', paddingLeft: '2%' }}>Country</div>
//                 </tr>
//                 {/* </tr> */}
//             </thead>
//             <tbody >
//                 {props.children}
//             </tbody>
//         </table>
//         {/* <div style={{ display: 'table', width: '100%', borderCollapse: 'collapse' }}>
//             <div style={{ display: 'table-header-group', backgroundColor: '#f8f9fa', borderBottom: '2px solid #ddd' }}>
//                 <div style={{ display: 'table-row' }}>

//                 </div>
//             </div>
//             <div style={{ display: 'table-body-group' }}>
//             </div>
//         </div> */}
//     </components.Menu>
// );

export const menu = (props) => {
    return (
        <components.Menu {...props}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead style={{ width: '100%' }}>
                    <tr style={{ width: '100%', display: 'flex', fontWeight: 'bold', backgroundColor: '#f8f9fa' }}>
                        <div style={{ width: '28%', paddingLeft: '4%' }}>Name</div>
                        <div style={{ width: '22%', paddingLeft: '3%' }}>Pancard no</div>
                        <div style={{ width: '30%', paddingLeft: '3%' }}>Id</div>
                        <div style={{ width: '20%', paddingLeft: '2%' }}>Country</div>
                    </tr>
                </thead>
                <tbody>
                    {props.children}
                </tbody>
            </table>
        </components.Menu>
    );
};


export const knockOffFormatOptionLabel = ({ id, label }) => {
    const valArr = label.split(" ");
    //console.log(valArr);
    let pending = valArr[0].split(':')[1];
    let total = valArr[1].split(':')[1];
    let received = valArr[2].split(':')[1]
    let voucher = valArr[4] + ' ' + valArr[3];
    let date = valArr[5];
    let ledgerInfo = "";
    if (valArr[6] !== undefined) {
        ledgerInfo = valArr[6].split(':')[1];
        ledgerInfo = ledgerInfo.split("^").join(' ');
    }
    let narration = valArr[7]?.split(':')[1];
    narration = narration?.split("^").join(' ');

    return (
        <div style={{ width: '100%', display: 'flex', paddingBottom: '0px' }}>
            <>
                <div style={{ width: '20%', paddingLeft: '3%' }}>
                    {pending}
                </div>
                <div style={{ width: '20%', paddingLeft: '3%' }}>
                    {total}
                </div>
                <div style={{ width: '20%', paddingLeft: '3%' }}>
                    {received}
                </div>
                <div style={{ width: '20%', paddingLeft: '3%' }}>
                    {voucher}
                </div>
                <div style={{ width: '20%', paddingLeft: '3%' }}>
                    {date}
                </div>
                <div style={{ width: '30%', paddingLeft: '3%' }}>
                    {ledgerInfo}
                </div>
                <div style={{ width: '50%', paddingLeft: '3%' }}>
                    {narration}
                </div>
            </>
        </div>
    )
}


export const accountMenu = (props) => (
    <components.Menu {...props}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead style={{ width: '100%' }}>
                <tr style={{ width: '100%', display: 'flex', fontWeight: 'bold', backgroundColor: '#f8f9fa', }}>
                    <div style={{ width: '15%', paddingLeft: '4%' }}>Group</div>
                    <div style={{ width: '15%', paddingLeft: '3%' }}>Acount</div>
                    <div style={{ width: '35%', paddingLeft: '3%' }}>Acount Name</div>
                    <div style={{ width: '35%', paddingLeft: '2%' }}>Group Name</div>
                </tr>
            </thead>
            <tbody >
                {props.children}
            </tbody>
        </table>
    </components.Menu>
);
export const accountFormatOptionLabel = ({ id, label }) => {
    const valArr = id.split("^");
    let group = valArr[1];
    let acount = valArr[2];
    let ledgerName = valArr[3]
    let groupName = valArr[10];

    return (
        <div style={{ width: '100%', display: 'flex', paddingBottom: '0px' }}>
            <>
                <div style={{ width: '15%', paddingLeft: '3%' }}>
                    {group}
                </div>
                <div style={{ width: '15%', paddingLeft: '3%' }}>
                    {acount}
                </div>
                <div style={{ width: '35%', paddingLeft: '3%' }}>
                    {ledgerName}
                </div>
                <div style={{ width: '35%', paddingLeft: '3%' }}>
                    {groupName}
                </div>
            </>
        </div>
    )
}

export const knockkOffMenu = (props) => (
    <components.Menu {...props}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead style={{ width: '100%' }}>
                <tr style={{ width: '100%', display: 'flex', fontWeight: 'bold', backgroundColor: '#f8f9fa', }}>
                    <div style={{ width: '20%', paddingLeft: '4%' }}>Pending</div>
                    <div style={{ width: '20%', paddingLeft: '3%' }}>Total</div>
                    <div style={{ width: '20%', paddingLeft: '3%' }}>Adjusted</div>
                    <div style={{ width: '20%', paddingLeft: '2%' }}>Voucher</div>
                    <div style={{ width: '20%', paddingLeft: '2%' }}>Date</div>
                    <div style={{ width: '20%', paddingLeft: '2%' }}>Individual</div>
                    <div style={{ width: '40%', paddingLeft: '2%' }}>Narration</div>
                </tr>
            </thead>
            <tbody >
                {props.children}
            </tbody>
        </table>
    </components.Menu>
);


export const vtmEnchasementMenu = (props) => (
    <components.Menu {...props}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead style={{ width: '100%' }}>
                <tr style={{ width: '100%', display: 'flex', fontWeight: 'bold', backgroundColor: '#f8f9fa', }}>
                    <div style={{ width: '5%', paddingLeft: '2%' }}>ISD</div>
                    <div style={{ width: '20%', paddingLeft: '2%' }}>Enchased Value</div>
                    <div style={{ width: '20%', paddingLeft: '2%' }}>Card No</div>
                    <div style={{ width: '20%', paddingLeft: '2%' }}>Ref No</div>
                    <div style={{ width: '20%', paddingLeft: '2%' }}>Issuer</div>
                    <div style={{ width: '20%', paddingLeft: '2%' }}>Croporate</div>
                </tr>
            </thead>
            <tbody style={{ paddingInline: '0px' }}>
                {props.children}
            </tbody>
        </table>
    </components.Menu>
);

export const vtmEnchasementFormatOptionLabel = ({ id, label, desc }) => {
    // const idArr = id.split("^");
    // const valArr = label.split("^");
    const descArr = desc.split('^');
    let isd = descArr[2];
    let enchValue = descArr[14];
    let issuer = descArr[3] + ' ' + descArr[4] + ' ' + descArr[5];
    let cardno = descArr[9];
    let refno = descArr[10];
    let croporate = (descArr[6] == 0 ? " " : descArr[6]) + " " + (descArr[7] == 0 ? " " : descArr[7]) + " " + descArr[8];


    return (
        <div style={{ width: '100%', display: 'flex', paddingBottom: '0px' }}>
            <>
                <div style={{ width: '5%', paddingLeft: '1%' }}>{isd}</div>
                <div style={{ width: '10%', paddingLeft: '1%' }}>{enchValue}</div>
                <div style={{ width: '20%', paddingLeft: '2%' }}>{cardno}</div>
                <div style={{ width: '20%', paddingLeft: '2%' }}>{refno}</div>
                <div style={{ width: '20%', paddingLeft: '1%' }}>{issuer}</div>
                <div style={{ width: '20%', paddingLeft: '2%' }}>{croporate}</div>
            </>
        </div>
    )
}

export const fetchEntityWiseStatePicklist = (searchString, country) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'entitywisestate',
        srch: searchString,
        country: country,
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}

export const fetchCancelledChequeBookBankPicklist = (searchString, groupCode, bankCode, location) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'chequebookcancelled',
        srch: searchString.trim(),
        groupCode: groupCode,
        bankCode: bankCode,
        location: location,
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}

export const fetchCancelledManualBookPicklist = (searchString, location) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'manualbookcancelled',
        srch: searchString.trim(),
        location: location,
        limit: 8
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}
export const fetchPanRelationShipPicklist = (searchString) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'panrelationship',
        srch: searchString
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}

export const fetchLocationAllowedWithoutHoPicklist = (searchString) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'allowedlocationwithoutho',
        srch: searchString
    };
    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });
    return result;
}
// export const fetchLocationAllowedWithoutHoPicklist = (searchString) => {
//     console.log('Hello')
//     const obj = {
//         sid: sessionStorage.getItem('sessionId'),
//         type: 'allowedlocationwithoutho',
//         srch: searchString
//     };
//     return axios.get(Common.apiPicklist, {
//         params: {
//             1: JSON.stringify(obj)
//         }
//     }).then(res => JSON.parse(res.data));
// };

export const fetchTdsList = (searchString) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'tdsList',
        srch: searchString
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}

export const tdsMenu = (props) => (
    <components.Menu {...props}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead style={{ width: '100%' }}>
                <tr style={{ width: '100%', display: 'flex', fontWeight: 'bold', backgroundColor: '#f8f9fa' }}>
                    <div style={{ width: '48%', paddingLeft: '2%' }}>Section</div>
                    <div style={{ width: '48%', paddingLeft: '2%' }}>Percentage</div>
                </tr>
            </thead>
            <tbody style={{ paddingInline: '0px' }}>
                {props.children}
            </tbody>
        </table>
    </components.Menu>
);

export const tdsFormatOptionLabel = ({ id, label }) => {
    const idArr = id.split('^');
    let section = (idArr[2] != 'null' && idArr[2] != '') ? idArr[2] : '';
    let percentage = (idArr[3] != 'null' && idArr[3] != '') ? idArr[3] + '%' : '';

    return (
        <div style={{ width: '100%', display: 'flex', paddingBottom: '0px' }}>
            <>
                <div style={{ width: '48%', paddingLeft: '2%' }}>{section}</div>
                <div style={{ width: '48%', paddingLeft: '2%' }}>{percentage}</div>
            </>
        </div>
    )
}


export const fetchPrincipleModulePicklist = (searchString) => {

    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'principlemodule',
        srch: searchString,
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;

}

export const fetchLedgerAllowedInactive = (searchString, location) => {
    var obj = {
        sid: sessionStorage.getItem('sessionId'),
        type: 'ledgerallowedIncludingInactive',
        srch: searchString,
        location: location
    };

    var result = axios.create({
        baseURL: Common.apiPicklist,
        headers: {},
    }).get('?1=' + JSON.stringify(obj)).then(result => {
        return JSON.parse(result.data);
    });

    return result;
}

